import { PlaceIdEnum, Suggestion } from "@b2bportal/ground-api";

export const getPickupLocationLabel = (
  pickupLocation: Suggestion | undefined
): string =>
  pickupLocation?.id.Id === PlaceIdEnum.Flight
    ? pickupLocation.label
    : "to pick-up location";
